import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ZOOMNOTESLABEL } from "../../shared/config";
import Components from "..";
import { cleanup } from "@testing-library/react";
import { circularProgressClasses } from "@mui/material";
import { doctorActions, patientActions, labActions } from "../../core/actions";
import Select, { createFilter } from "react-select";
import {
  EPRESCRIPTION,
  LAB_ADMIN,
  RADIOLOGY,
  ROLE_KEYS,
  ULTRASOUND,
  LAB,
} from "../../shared/constants";
import CardContent from "@mui/material/CardContent";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { importPackageData } from "../../data/labPackageDataStore";

function TemplatePreview(props) {
  const [status, setStatus] = useState(undefined);
  const [templateId, setTemplateId] = useState();
  const [pData, setPData] = useState([]);
  const [templateList, setTemplateList] = useState();
  const dispatch = useDispatch();
  const [deptoptions, setDeptOption] = useState([]);
  const [catoptions, setCatOption] = useState([]);
  const [subcatoptions, setSubCatOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [flag, setFlag] = useState(false);
  const [comflag, setComflag] = useState();
  const [comid, setComid] = useState();
  const [procedure, setProcedure] = useState();

  const role_name = JSON.parse(localStorage.getItem("role"));

  const templates = useSelector((state) => state.doctorDetailsState.templates);
  const templateMasterList = useMemo(() => {
    if (Array.isArray(templates?.templateMasterList)) {
      return templates.templateMasterList;
    }
    if (Array.isArray(templates)) {
      return templates;
    }
    return [];
  }, [templates]);
  let placeholdertext = "Select value";

  useEffect(() => {
    if (props.mode !== "editComposition" && templateMasterList.length === 0) {
      dispatch(
        doctorActions.listTemplates({}, (resCb) => {
          console.log("listTemplates API Response:", resCb);
        })
      );
    }
  }, [dispatch, props.mode, templateMasterList.length]);

  useEffect(() => {
    // var role_name = JSON.parse(localStorage.getItem("role"));
    console.log("role", role_name);
    setProcedure(props.selectedProcedure);
    if (props.mode == "editComposition") {
      console.log("props:", props);
      setComid(props.templateId);
      getTemplate(props.selectedProcedure.templateId);
      // console.log("proceduretemplateid",props.templateId)
      setComflag(props.mode);
      console.log("procedure", props.selectedProcedure);
      setProcedure(props.selectedProcedure);
      // put console here
    } else {
      console.log("props:", props);
      setProcedure(props.selectedProcedure);
      let patientId =
        props.fileUploadcontent?.id ?? props.fileUploadcontent?.patientId;
      let visitId = props.fileUploadcontent.visitId;
      let patientDetails = [];
      let pOpt = {};
      pOpt["patientId"] = patientId;
      pOpt["visitId"] = visitId;
      patientDetails.push(pOpt);
      console.log("templateMasterList:", templateMasterList, typeof templates);
      setPData([...patientDetails]);
      console.log("pData:", patientDetails);
      console.log("pData:", pData);
      console.log("templates:", templates);
      setSelectedOption([...templateMasterList]);
      // setTemplateList(templates.templateMasterList);
      console.log("templates:", templateMasterList);
      // console.log("templateList:",templateList);
      console.log("props:", props);
      console.log("fileUploadcontent", props.fileUploadcontent);
      let deptOptions = [];
      let catOptions = [];
      let subCatOptions = [];
      if (templateMasterList.length > 0) {
        if (
          props.selectedProcedure?.packageService?.serviceType === LAB &&
          props.compositeUltrasound === false
        ) {
          for (let temp of templateMasterList) {
            if (temp.department == "Laboratory") {
              let dOpt = {},
                cOpt = {},
                scOpt = {};
              dOpt["id"] = temp.id;
              dOpt["value"] = temp.templateId;
              // dOpt['label'] = temp.templateId;
              dOpt["label"] = temp.name;
              cOpt["id"] = temp.id;
              cOpt["value"] = temp.templateId + temp.category;
              cOpt["label"] = temp.templateId + "(" + temp.category + ")";
              scOpt["id"] = temp.id;
              scOpt["value"] = temp.templateId + temp.subcategory;
              scOpt["label"] = temp.templateId + "(" + temp.subcategory + ")";
              deptOptions.push(dOpt);
              catOptions.push(cOpt);
              subCatOptions.push(scOpt);
              console.log("opt:", dOpt, cOpt, scOpt);
              console.log("Options:", deptOptions, catOptions, subCatOptions);
            }
          }
          console.log("selectedOptionss", selectedOption);
          getTemplate(props.templateId);
          setFlag(true);
        } else if (
          props.selectedProcedure?.packageService?.serviceType === ULTRASOUND ||
          props.compositeUltrasound === true
        ) {
          for (let temp of templateMasterList) {
            if (temp.department == "Ultrasound") {
              let dOpt = {},
                cOpt = {},
                scOpt = {};
              dOpt["id"] = temp.id;
              dOpt["value"] = temp.templateId;
              dOpt["label"] = temp.name;
              cOpt["id"] = temp.id;
              cOpt["value"] = temp.templateId + temp.category;
              cOpt["label"] = temp.templateId + "(" + temp.category + ")";
              scOpt["id"] = temp.id;
              scOpt["value"] = temp.templateId + temp.subcategory;
              scOpt["label"] = temp.templateId + "(" + temp.subcategory + ")";
              deptOptions.push(dOpt);
              catOptions.push(cOpt);
              subCatOptions.push(scOpt);
              console.log("opt:", dOpt, cOpt, scOpt);
              console.log("Options:", deptOptions, catOptions, subCatOptions);
            }
          }
          console.log("selectedOptionss", selectedOption);
          getTemplate(props.templateId);
          console.log("selectedOptionss", selectedOption);
        } else {
          console.log("inside tem if con", templateMasterList);
          for (let temp of templateMasterList) {
            if (!(temp.department == "Ultrasound")) {
              let dOpt = {},
                cOpt = {},
                scOpt = {};
              dOpt["id"] = temp.id;
              dOpt["value"] = temp.templateId;
              // dOpt['label'] = temp.templateId;
              dOpt["label"] = temp.name;
              cOpt["id"] = temp.id;
              cOpt["value"] = temp.templateId + temp.category;
              cOpt["label"] = temp.templateId + "(" + temp.category + ")";
              scOpt["id"] = temp.id;
              scOpt["value"] = temp.templateId + temp.subcategory;
              scOpt["label"] = temp.templateId + "(" + temp.subcategory + ")";
              deptOptions.push(dOpt);
              catOptions.push(cOpt);
              subCatOptions.push(scOpt);
              console.log("opt:", dOpt, cOpt, scOpt);
              console.log("Options:", deptOptions, catOptions, subCatOptions);
            }
          }
        }
      }

      console.log("options1:", deptoptions, catoptions, subcatoptions);
      setDeptOption([...deptOptions]);
      setCatOption([...catOptions]);
      setSubCatOption([...subCatOptions]);
      console.log("options2:", deptoptions, catoptions, subcatoptions);
    }
  }, [
    props.mode,
    props.templateId,
    props.fileUploadcontent,
    props.selectedProcedure,
    props.compositeUltrasound,
    templateMasterList,
  ]);

  const closeModal = () => {
    props.ontemplatePreviewModalClose();
    // window.location.href = `/patient/:patientid/:visitid/:groupid`;
  };

  const handleChange = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    console.log("event:", selectedOption);
    setTemplateId(selectedOption.value);
    setFlag(true);
    setSelectedOption(selectedOption);
  };

  const getTemplate = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    console.log("event:", selectedOption);
    setTemplateId(selectedOption);
    // let data = props.selectedProcedure;
    const procedure = props.selectedProcedure || {};
    const cleanedData = {
      ...procedure,
      combinedProcedures: procedure.combinedProcedures?.map((p) => ({
        id: p.id,
        patientId: p.patientId,
        visitId: p.visitId,
        gvid: p.gvid,
        notes: p.notes,
      })),
      combinedEhrPrescriptions: undefined,
      combinedEhrLabel: undefined,
    };
    console.log("falg", flag);
    dispatch(
      labActions.getPackageTestnames(cleanedData, selectedOption, (resCb) => {
        console.log("response of packages", resCb);

        // Example: store in a shared module or exportable variable
        importPackageData(resCb); // custom function to send it to index.js
      })
    );
  };

  const submit = () => {
    // console.log("procedureDetail submit:",procedureDetail);
    // dispatch(doctorActions.addProcedure(procedureDetail,(resCb) => {
    //     console.log("procedureDetail:",procedureDetail);
    //     if(resCb){
    //         setStatus({ type: 'success' });
    //     }
    // }));
  };

  const closeFormSchema = (event) => {
    setFlag(false);
    props.ontemplatePreviewModalClose(event);
  };

  return (
    <>
      <div className=" bg-none nav-wrapper h-100 d-flex flex-column template-view">
        <div className="d-flex">
          {/* <span className="topright d-flex justify-content-end pl-4 pt-3 mr-4"  onClick={(event)=>closeModal(event)}>X</span>        */}
          <IconButton
            aria-label="close"
            onClick={(e) => closeModal(e)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className="d-flex" style={{ overflowY: "auto" }}>
          <CardContent className="w-100">
            <div className="search-container">
              {/* {selectedOption && 
                                 <h5>{selectedOption}</h5> 
                                } */}
              {comflag == "editComposition" ? (
                ""
              ) : (
                <Select
                  name="template"
                  placeholder={"Search template...."}
                  // value={selectedOption}
                  onChange={handleChange}
                  isClearable
                  isSearchable
                  options={deptoptions}
                  filterOption={createFilter(deptoptions)}
                  patientInfo={props.patientInfo}
                  selectedProcedure={procedure}
                // defaultValue={selectedOption}
                // style={{ padding: `0px 30px` }}
                ></Select>
              )}

              <div>
                {comflag == "editComposition" && (
                  <div className="py-3 px-0">
                    {/* ✅ Grouped EHR — render all medicines stacked */}
                    {procedure?.combinedEhrPrescriptions &&
                      procedure.combinedEhrPrescriptions.length > 0 ? (
                      procedure.combinedEhrPrescriptions.map((p, i) => (
                        <div
                          key={i}
                          style={{
                            marginTop: i === 0 ? "0px" : "-24px",
                          }}
                        >
                          <Components.PatientSchema
                            templateData={comid}
                            patientData={pData}
                            selectedProcedure={p}
                            flags={comflag}
                            patientInfo={props.patientInfo}
                            mode="edit"
                            role={role_name}
                            onModalClose={(event) => closeFormSchema(event)}
                            selectedTests={props.selectedTests}
                          />
                        </div>
                      ))
                    ) : (
                      // ✅ Single prescription — original behavior
                      <Components.PatientSchema
                        templateData={comid}
                        patientData={pData}
                        selectedProcedure={procedure}
                        flags={comflag}
                        patientInfo={props.patientInfo}
                        mode="edit"
                        role={role_name}
                        onModalClose={(event) => closeFormSchema(event)}
                        selectedTests={props.selectedTests}
                      />
                    )}
                  </div>
                )}

                {flag == true && (
                  <div className="py-0 px-0">
                    {procedure?.packageService?.serviceType === ULTRASOUND ||
                      props.compositeUltrasound === true ? (
                      <Components.RadiologyTemplate
                        // templateData={templateId}
                        patientData={pData}
                        selectedProcedure={procedure}
                        patientInfo={props.patientInfo}
                        mode="new"
                        onModalClose={(event) => closeFormSchema(event)}
                        templateId={templateId}
                      />
                    ) : (
                      <Components.PatientSchema
                        templateData={templateId}
                        procedureList={props.patientProcedureList}
                        patientData={pData}
                        selectedProcedure={procedure}
                        patientInfo={props.patientInfo}
                        mode="new"
                        role={role_name}
                        onModalClose={(event) => closeFormSchema(event)}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </div>
      </div>
    </>
  );
}

export default TemplatePreview;
